// import React, { useState, useEffect, useRef } from 'react';
// import Papa from 'papaparse';
// import { useJobContext } from '../../context/JobContext';
// import { Input, Scroll, Selectbox } from '../../css/Shared';
// import api from '../../components/Api';
// import{useAppContext} from '../../context/AppContext'

// const CSVRemapper = ({ goToNextTab,goToPrevTab }) => {
//   const fileInputRef = useRef(null);

//   const {
//     formData,
//     setFormData,
//     finalCSV,
//     setFinalCSV,
//     originalCSVData,
//     setOriginalCSVData,
//     csvMeta,
//     setCsvMeta,
//       csvMappings,
//   setCsvMappings,
//   } = useJobContext();

//   const [csvData, setCsvData] = useState([]);        // full CSV data (original)
//   const [headers, setHeaders] = useState([]);        // headers row
//   const [remappedHeaders, setRemappedHeaders] = useState({}); // original -> target mapping
//   const [usedHeaders, setUsedHeaders] = useState([]);         // track which target headers are used
//   const [error, setError] = useState('');
//   const [recordIndex, setRecordIndex] = useState(1); // 1 = first record
// const [hasRemapped, setHasRemapped] = useState(false);
// const [isDragging, setIsDragging] = useState(false); // new state
//   const [suppressionLists, setSuppressionLists] = useState([]);
//   const [seedLists, setSeedLists] = useState([]);
//   const [loadingLists, setLoadingLists] = useState(true);
//   const {authState} = useAppContext()
//   const headerOptions = [
//     'Select Header',
//     'prefix', 'firstName', 'lastName', 'middleName', 'company', 'suffix',
//     'address1', 'address2', 'address3', 'city', 'state', 'zip',
//     'walkSequence', 'carrierRoute',
//     'custom1', 'custom2', 'custom3', 'custom4', 'custom5',
//     'custom6', 'custom7', 'Custom8', 'Custom9', 'Custom10',
//     'Custom11', 'Custom12', 'Custom13', 'Custom14', 'Custom15',
//     'Custom16', 'Custom17', 'Custom18', 'Custom19', 'Custom20',
//   ];

//   const headerMapping = {
//     prefix: ['prefix', 'pre', 'title'],
//     firstName: ['first name', 'firstname', 'fname', 'given name','first'],
//     lastName: ['last name', 'lastname', 'lname', 'surname', 'last_name','last'],
//     middleName: ['middle name', 'middlename', 'mname','middle'],
//         company: ['company'],
//     suffix: ['suffix', 'sfx'],
//     address1: ['address', 'address1', 'address 1', 'street', 'street1'],
//     address2: ['address2', 'address 2', 'street2', 'apt', 'apartment'],
//     address3: ['address3', 'address 3'],
//     city: ['city', 'town'],
//     state: ['state', 'st', 'province'],
//     zip: ['zip', 'postal code', 'zipcode'],
//     walkSequence: ['walk sequence', 'walksequence'],
//     carrierRoute: ['carrier route', 'carrierroute'],
//     custom1: ['custom1', 'cust1'],
//     custom2: ['custom2', 'cust2'],
//     custom3: ['custom3', 'cust3'],
//     custom4: ['custom4', 'cust4'],
//     custom5: ['custom5', 'cust5'],
//     custom6: ['custom6', 'cust6'],
//     custom7: ['custom7', 'cust7'],
//     Custom8: ['custom8', 'cust8'],
//     Custom9: ['custom9', 'cust9'],
//     Custom10: ['custom10', 'cust10'],
//     Custom11: ['custom11', 'cust11'],
//     Custom12: ['custom12', 'cust12'],
//     Custom13: ['custom13', 'cust13'],
//     Custom14: ['custom14', 'cust14'],
//     Custom15: ['custom15', 'cust15'],
//     Custom16: ['custom16', 'cust16'],
//     Custom17: ['custom17', 'cust17'],
//     Custom18: ['custom18', 'cust18'],
//     Custom19: ['custom19', 'cust19'],
//     Custom20: ['custom20', 'cust20'],
//   };
// console.log(authState)

//     useEffect(() => {
//     const fetchLists = async () => {
//       console.log('fetch')
//       try {
//         setLoadingLists(true);
//         const [suppressRes, seedsRes] = await Promise.all([
//            api.post('/permits/suppress/all', { id: authState.user.company._id}),
//           api.post('/permits/seeds/all', { id: authState.user.company._id})
 
//         ]);

//         console.log('ooo'+seedsRes)
//         setSuppressionLists(suppressRes.data || []);
//         setSeedLists(seedsRes.data || []);
//       } catch (err) {
//         console.error('Failed to load lists:', err);
//       } finally {
//         setLoadingLists(false);
//       }
//     };


//     fetchLists();
//   }, []);


// useEffect(() => {
//   if (!originalCSVData || originalCSVData.length === 0) return;

//   setCsvData(originalCSVData);
//   setHeaders(originalCSVData[0]);
//   setRecordIndex(1);

//   // ✅ restore saved mappings WITHOUT invalidating remap
//   if (csvMappings) {
//     setRemappedHeaders(csvMappings.remappedHeaders);
//     setUsedHeaders(csvMappings.usedHeaders);
//     return;
//   }

//   // 🔁 only auto-map on first load
//   const preservedRemap = {};
//   const used = [];

//   originalCSVData[0].forEach((h) => {
//     let mapped = 'Select Header';
//     for (const target in headerMapping) {
//       if (
//         headerMapping[target].some(
//           (v) => v.toLowerCase() === h.toLowerCase()
//         ) &&
//         !used.includes(target)
//       ) {
//         mapped = target;
//         used.push(target);
//         break;
//       }
//     }
//     preservedRemap[h] = mapped;
//   });

//   setRemappedHeaders(preservedRemap);
//   setUsedHeaders(used);
// }, [originalCSVData]); // 🔥 REMOVE csvMappings from deps



//   // --- FILE UPLOAD ---
//   const handleFileSelect = (e) => {
//   setError('');

//   // --- CLEAR OLD CSV DATA FIRST ---
//   setCsvData([]);
//   setHeaders([]);
//   setRemappedHeaders({});
//   setUsedHeaders([]);
//   setRecordIndex(1);
//   setHasRemapped(false);
//   setOriginalCSVData(null);
//   setFinalCSV(null);
//   setCsvMeta({ name: '', records: 0 });

//   const file = e.target.files[0];
//   if (!file || file.type !== 'text/csv') {
//     setError('Please upload a valid CSV file.');
//     return;
//   }

//   Papa.parse(file, {
//     complete: (result) => {
//       if (result.data.length === 0) {
//         setError('CSV is empty.');
//         setHasRemapped(false);
//         return;
//       }

//       const newHeaders = result.data[0];
//       setCsvData(result.data);
//       setHeaders(newHeaders);
//       setRecordIndex(1);

//       // auto-map headers
//       const preservedRemap = {};
//       const used = [];
//       newHeaders.forEach((h) => {
//         let mapped = 'Select Header';
//         for (const target in headerMapping) {
//           if (
//             headerMapping[target].some((v) => v.toLowerCase() === h.toLowerCase()) &&
//             !used.includes(target)
//           ) {
//             mapped = target;
//             used.push(target);
//             break;
//           }
//         }
//         preservedRemap[h] = mapped;
//       });
//       setRemappedHeaders(preservedRemap);
//       setUsedHeaders(used);

//       // save to context
//       setOriginalCSVData(result.data);
//       setFinalCSV(new Blob([Papa.unparse(result.data)], { type: 'text/csv' }));
//       setCsvMeta({ name: file.name, records: result.data.length - 1 });
//     },
//     header: false,
//     skipEmptyLines: true,
//   });
// };


//   const handleHeaderChange = (original, newHeader) => {
//   setHasRemapped(false); // 👈 this is correct here

//   setRemappedHeaders((prev) => {
//     const updated = { ...prev };

//     if (newHeader !== 'Select Header') {
//       Object.keys(updated).forEach((key) => {
//         if (key !== original && updated[key] === newHeader) {
//           updated[key] = 'Select Header';
//         }
//       });
//     }

//     updated[original] = newHeader;
//     setUsedHeaders(
//       Object.values(updated).filter((v) => v !== 'Select Header')
//     );

//     return updated;
//   });
// };




// const remapCSV = () => {
//   if (!csvData.length) return;

//   // persist mappings
//   setCsvMappings({
//     remappedHeaders,
//     usedHeaders,
//   });

//   const targetHeaders = headerOptions.filter(
//     (h) => h !== 'Select Header'
//   );

//   const targetToOriginal = {};
//   const assignedOriginals = new Set();

//   // 1️⃣ normal user-selected mappings
//   Object.keys(remappedHeaders).forEach((original) => {
//     const mapped = remappedHeaders[original];
//     if (targetHeaders.includes(mapped)) {
//       targetToOriginal[mapped] = original;
//       assignedOriginals.add(original);
//     }
//   });

//   // 2️⃣ find unmapped original headers
//   const unmappedOriginals = headers.filter(
//     (h) => !assignedOriginals.has(h)
//   );

//   // 3️⃣ find unused Custom fields (in order)
//   const customFields = targetHeaders.filter((h) =>
//     h.toLowerCase().startsWith('custom')
//   );

//   const unusedCustoms = customFields.filter(
//     (c) => !targetToOriginal[c]
//   );

//   // 4️⃣ auto-assign unmapped originals → Custom1..Custom20
//   unmappedOriginals.forEach((original, idx) => {
//     if (idx < unusedCustoms.length) {
//       targetToOriginal[unusedCustoms[idx]] = original;
//     }
//   });

//   // 5️⃣ build new CSV
//   const newData = [];
//   newData.push(targetHeaders);

//   for (let i = 1; i < csvData.length; i++) {
//     const row = targetHeaders.map((th) => {
//       const orig = targetToOriginal[th];
//       if (orig) {
//         const idx = headers.indexOf(orig);
//         return csvData[i][idx] || '';
//       }
//       return '';
//     });
//     newData.push(row);
//   }

//   setFinalCSV(new Blob([Papa.unparse(newData)], { type: 'text/csv' }));
//   setCsvMeta({ name: csvMeta.name, records: newData.length - 1 });

//   setHasRemapped(true);
// };





// console.log(suppressionLists)

 
//   const handlePrev = () => {
//     remapCSV();
//     goToPrevTab();
//   };
//   const handleNext = () => {
//     remapCSV();
//     goToNextTab();
//   };

//   const handleRecordNavigation = (direction) => {
//     if (!csvData.length) return;
//     let newIndex = recordIndex + (direction === 'next' ? 1 : -1);
//     if (newIndex < 1) newIndex = 1;
//     if (newIndex >= csvData.length) newIndex = csvData.length - 1;
//     setRecordIndex(newIndex);
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-lg font-bold mb-2">Upload CSV</h2>
//       <div
//   className="border-2 p-4 text-center cursor-pointer hover:border-blue-500 mb-2"
//   style={{ borderStyle: 'dashed', borderColor: isDragging ? 'green' : '#d1d5db' }} // conditional border
//   onClick={() => fileInputRef.current.click()}
//   onDragOver={(e) => {
//     e.preventDefault();
//     setIsDragging(true); // highlight on drag over
//   }}
//   onDragLeave={() => setIsDragging(false)} // remove highlight when leaving
//   onDrop={(e) => {
//     e.preventDefault();
//     setIsDragging(false); // remove highlight on drop
//     const file = e.dataTransfer.files[0];
//     if (file) {
//       handleFileSelect({ target: { files: [file] } });
//     }
//   }}
// >
//   <p className="text-gray-500 text-xs">Click or drag CSV file here</p>
//   <Input
//     type="file"
//     accept=".csv"
//     ref={fileInputRef}
//     className="hidden"
//     onChange={handleFileSelect}
//   />
// </div>
    
//       {error && <p className="text-red-500 text-xs">{error}</p>}

//       {headers.length > 0 && (
//         <Scroll height="250px">
//         <div className="mt-3">
//           <p className="text-sm font-semibold">{csvMeta.name} ({csvMeta.records} records)</p>

//           <table className="w-full border-collapse text-xs mt-1">
//             <thead>
//               <tr className="bg-gray-200">
//                 <th className="border p-1">Original Header</th>
//                 <th className="border p-1">Sample Data</th>
//                 <th className="border p-1">Remapped Header</th>
//               </tr>
//             </thead>
//             <tbody>
//               {headers.map((h, idx) => (
//                 <tr key={h}>
//                   <td className="border p-1">{h}</td>
//                   <td className="border p-1">{csvData[recordIndex]?.[idx] || ''}</td>
//                   <td className="border p-1">
//                     <select
//                       value={remappedHeaders[h] || 'Select Header'}
//                       onChange={(e) => handleHeaderChange(h, e.target.value)}
//                       className="w-full text-xs"
//                     >
//                       {headerOptions.map((opt) => (
//                         <option
//                           key={opt}
//                           value={opt}
//                         >
//                           {opt}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

       

//           <div className="flex justify-end mt-3 space-x-2">
          

//           </div>
//         </div>
//         </Scroll>
//       ) }
//       {headers.length > 0 && (
//          <div className="flex justify-between items-center mt-2 text-xs">
//             <div style={{flex:'1',textAlign:'right'}}>
//               {recordIndex > 1 ?   <button
//               onClick={() => handleRecordNavigation('prev')}
//               disabled={recordIndex <= 1}
//               className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
//             >
//               Prev
//             </button>: null}
          
//             </div>
//             <div style={{textAlign:'center',padding:'0px  20px'}}>
//             <span>Record {recordIndex} of {csvData.length - 1}</span>
//             </div>
//             <div style={{flex:'1',textAlign:'left'}}>
//               {recordIndex < csvData.length - 1  ? <button
//   onClick={() => handleRecordNavigation('next')}
//   disabled={recordIndex >= csvData.length - 1}
//   className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
// >
//   Next
// </button>: null}



//             </div>
//           </div>
//       )}

//             {/* ============ SUPPRESSION / SEEDS ============ */}

//       <div className="border-t pt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
//         <div>
//           <div className="text-xs font-medium text-gray-700 mb-2">
//             Do Not Mail (Suppression) List
//           </div>
//           <Selectbox
//             value={formData.dnmMode || ''}
//             onChange={e =>
//               setFormData({
//                 ...formData,
//                 dnmMode: e.target.value,
//                 selectedSuppressionListIds: [] // reset on mode change
//               })
//             }
//           >
//             <option value="">None</option>
//             <option value="existing">Select Existing</option>
//           </Selectbox>

//           {loadingLists ? (
//             <p className="text-xs text-gray-500 mt-2">Loading suppression lists...</p>
//           ) : formData.dnmMode === 'existing' && (
//             <div className="mt-3">
//               <label className="text-xs text-gray-600 block mb-1">
//                 Choose Suppression List(s)
//               </label>
           
// <Selectbox
//   multiple
//   value={formData.selectedSuppressionListIds || []}
//   onChange={e => {
//     const options = [...e.target.options];
//     const selected = options
//       .filter(option => option.selected)
//       .map(option => option.value);

//     // Build object with name + count
//     const details = {};
//     selected.forEach(id => {
//       const list = suppressionLists.find(l => l._id === id);
//       details[id] = {
//         name: list?.suppressionListName || 'Unnamed List',
//         count: list?.entries?.length || 0,
//       };
//     });

//     setFormData({
//       ...formData,
//       selectedSuppressionListIds: selected,
//       selectedSuppressionLists: details,
//     });
//   }}
// >
//   {suppressionLists.length === 0 ? (
//     <option disabled>No suppression lists available</option>
//   ) : (
//     suppressionLists.map(list => (
//       <option key={list._id} value={list._id}>
//         {list.suppressionListName || 'Unnamed List'}
//        {list.seeds && ` - (${list.seeds.length} address)`}
//       </option>
//     ))
//   )}
// </Selectbox>

//               <p className="text-xs text-gray-500 mt-1">
//                 Hold Ctrl/Cmd to select multiple list
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Seed Records – already multiple */}
//         <div>
//           <div className="text-xs font-medium text-gray-700 mb-2">
//             Seed Records
//           </div>
//           <Selectbox
//             value={formData.seedMode || ''}
//             onChange={e =>
//               setFormData({
//                 ...formData,
//                 seedMode: e.target.value,
//                 selectedSeedListIds: [] // reset on mode change
//               })
//             }
//           >
//             <option value="">None</option>
//             <option value="existing">Select Existing</option>
//           </Selectbox>

//           {loadingLists ? (
//             <p className="text-xs text-gray-500 mt-2">Loading seed lists...</p>
//           ) : (formData.seedMode === 'existing' || formData.seedMode === 'both') && (
//             <div className="mt-3">
//               <label className="text-xs text-gray-600 block mb-1">
//                 Choose Seed List(s)
//               </label>
//            <Selectbox
//   multiple
//   value={formData.selectedSeedListIds || []}
//   onChange={e => {
//     const options = [...e.target.options];
//     const selected = options
//       .filter(option => option.selected)
//       .map(option => option.value);

//     // Build object with name + count
//     const details = {};
//     selected.forEach(id => {
//       const list = seedLists.find(l => l._id === id);
//       details[id] = {
//         name: list?.seedListName || 'Unnamed Seed List',
//         count: list?.seeds?.length || 0,
//       };
//     });

//     setFormData({
//       ...formData,
//       selectedSeedListIds: selected,
//       selectedSeedLists: details,
//     });
//   }}
// >
//   {seedLists.length === 0 ? (
//     <option disabled>No seed lists available</option>
//   ) : (
//     seedLists.map(list => (
//       <option key={list._id} value={list._id}>
//         {list.seedListName || 'Unnamed Seed List'}
//         {list.seeds && ` - (${list.seeds.length} seeds)`}
//       </option>
//     ))
//   )}
// </Selectbox>
//               <p className="text-xs text-gray-500 mt-1">
//                 Hold Ctrl/Cmd to select multiple lists
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

    
//        <div className="flex justify-end mt-3 space-x-2">
//    <button
//     onClick={handlePrev}
//     className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
//   >
//     Prev &lt;
//   </button>
//   <button
//     onClick={handleNext}
//     className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
//   >
//     Next &gt;
//   </button>
// </div>
//     </div>
//   );
// };

// export default CSVRemapper;


import React, { useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import { useJobContext } from '../../context/JobContext';
import { Input, Scroll } from '../../css/Shared';

const CSVRemapper = ({ goToNextTab, goToPrevTab }) => {
  const fileInputRef = useRef(null);

  const {
    formData,
    setFormData,
    finalCSV,
    setFinalCSV,
    originalCSVData,
    setOriginalCSVData,
    csvMeta,
    setCsvMeta,
    csvMappings,
    setCsvMappings,
  } = useJobContext();

  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [remappedHeaders, setRemappedHeaders] = useState({});
  const [usedHeaders, setUsedHeaders] = useState([]);
  const [error, setError] = useState('');
  const [recordIndex, setRecordIndex] = useState(1);
  const [hasRemapped, setHasRemapped] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const headerOptions = [
    'Select Header',
    'prefix','firstName','lastName','middleName','company','suffix',
    'address1','address2','address3','city','state','zip',
    'walkSequence','carrierRoute',
    'custom1','custom2','custom3','custom4','custom5',
    'custom6','custom7','Custom8','Custom9','Custom10',
    'Custom11','Custom12','Custom13','Custom14','Custom15',
    'Custom16','Custom17','Custom18','Custom19','Custom20'
  ];

  const headerMapping = {
    prefix: ['prefix','pre','title'],
    firstName: ['first name','firstname','fname','given name','first'],
    lastName: ['last name','lastname','lname','surname','last_name','last'],
    middleName: ['middle name','middlename','mname','middle'],
    company: ['company'],
    suffix: ['suffix','sfx'],
    address1: ['address','address1','address 1','street','street1'],
    address2: ['address2','address 2','street2','apt','apartment'],
    address3: ['address3','address 3'],
    city: ['city','town'],
    state: ['state','st','province'],
    zip: ['zip','postal code','zipcode'],
    walkSequence: ['walk sequence','walksequence'],
    carrierRoute: ['carrier route','carrierroute'],
  };

  useEffect(() => {
    if (!originalCSVData || originalCSVData.length === 0) return;

    setCsvData(originalCSVData);
    setHeaders(originalCSVData[0]);
    setRecordIndex(1);

    if (csvMappings) {
      setRemappedHeaders(csvMappings.remappedHeaders);
      setUsedHeaders(csvMappings.usedHeaders);
      return;
    }

    const preservedRemap = {};
    const used = [];

    originalCSVData[0].forEach((h) => {
      let mapped = 'Select Header';
      for (const target in headerMapping) {
        if (
          headerMapping[target].some(
            (v) => v.toLowerCase() === h.toLowerCase()
          ) &&
          !used.includes(target)
        ) {
          mapped = target;
          used.push(target);
          break;
        }
      }
      preservedRemap[h] = mapped;
    });

    setRemappedHeaders(preservedRemap);
    setUsedHeaders(used);
  }, [originalCSVData]);

  const handleFileSelect = (e) => {
    setError('');

    setCsvData([]);
    setHeaders([]);
    setRemappedHeaders({});
    setUsedHeaders([]);
    setRecordIndex(1);
    setHasRemapped(false);
    setOriginalCSVData(null);
    setFinalCSV(null);
    setCsvMeta({ name: '', records: 0 });

    const file = e.target.files[0];
    if (!file || file.type !== 'text/csv') {
      setError('Please upload a valid CSV file.');
      return;
    }

    Papa.parse(file, {
      complete: (result) => {
        if (result.data.length === 0) {
          setError('CSV is empty.');
          setHasRemapped(false);
          return;
        }

        const newHeaders = result.data[0];
        setCsvData(result.data);
        setHeaders(newHeaders);
        setRecordIndex(1);

        const preservedRemap = {};
        const used = [];

        newHeaders.forEach((h) => {
          let mapped = 'Select Header';
          for (const target in headerMapping) {
            if (
              headerMapping[target].some(
                (v) => v.toLowerCase() === h.toLowerCase()
              ) &&
              !used.includes(target)
            ) {
              mapped = target;
              used.push(target);
              break;
            }
          }
          preservedRemap[h] = mapped;
        });

        setRemappedHeaders(preservedRemap);
        setUsedHeaders(used);

        setOriginalCSVData(result.data);
        setFinalCSV(new Blob([Papa.unparse(result.data)], { type: 'text/csv' }));
        setCsvMeta({ name: file.name, records: result.data.length - 1 });
      },
      header: false,
      skipEmptyLines: true,
    });
  };

  const handleHeaderChange = (original, newHeader) => {
    setHasRemapped(false);

    setRemappedHeaders((prev) => {
      const updated = { ...prev };

      if (newHeader !== 'Select Header') {
        Object.keys(updated).forEach((key) => {
          if (key !== original && updated[key] === newHeader) {
            updated[key] = 'Select Header';
          }
        });
      }

      updated[original] = newHeader;

      setUsedHeaders(
        Object.values(updated).filter((v) => v !== 'Select Header')
      );

      return updated;
    });
  };

  const remapCSV = () => {
    if (!csvData.length) return;

    setCsvMappings({
      remappedHeaders,
      usedHeaders,
    });

    const targetHeaders = headerOptions.filter(
      (h) => h !== 'Select Header'
    );

    const targetToOriginal = {};
    const assignedOriginals = new Set();

    Object.keys(remappedHeaders).forEach((original) => {
      const mapped = remappedHeaders[original];
      if (targetHeaders.includes(mapped)) {
        targetToOriginal[mapped] = original;
        assignedOriginals.add(original);
      }
    });

    const unmappedOriginals = headers.filter(
      (h) => !assignedOriginals.has(h)
    );

    const customFields = targetHeaders.filter((h) =>
      h.toLowerCase().startsWith('custom')
    );

    const unusedCustoms = customFields.filter(
      (c) => !targetToOriginal[c]
    );

    unmappedOriginals.forEach((original, idx) => {
      if (idx < unusedCustoms.length) {
        targetToOriginal[unusedCustoms[idx]] = original;
      }
    });

    const newData = [];
    newData.push(targetHeaders);

    for (let i = 1; i < csvData.length; i++) {
      const row = targetHeaders.map((th) => {
        const orig = targetToOriginal[th];
        if (orig) {
          const idx = headers.indexOf(orig);
          return csvData[i][idx] || '';
        }
        return '';
      });
      newData.push(row);
    }

    setFinalCSV(new Blob([Papa.unparse(newData)], { type: 'text/csv' }));
    setCsvMeta({ name: csvMeta.name, records: newData.length - 1 });

    setHasRemapped(true);
  };

  const handlePrev = () => {
    remapCSV();
    goToPrevTab();
  };

  const handleNext = () => {
    remapCSV();
    goToNextTab();
  };

  const handleRecordNavigation = (direction) => {
    if (!csvData.length) return;

    let newIndex = recordIndex + (direction === 'next' ? 1 : -1);

    if (newIndex < 1) newIndex = 1;
    if (newIndex >= csvData.length) newIndex = csvData.length - 1;

    setRecordIndex(newIndex);
  };

  return (
    <div className="p-4">

      <h2 className="text-lg font-bold mb-2">Upload CSV</h2>

      <div
        className="border-2 p-4 text-center cursor-pointer hover:border-blue-500 mb-2"
        style={{
          borderStyle: 'dashed',
          borderColor: isDragging ? 'green' : '#d1d5db'
        }}
        onClick={() => fileInputRef.current.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          const file = e.dataTransfer.files[0];
          if (file) {
            handleFileSelect({ target: { files: [file] } });
          }
        }}
      >
        <p className="text-gray-500 text-xs">
          Click or drag CSV file here
        </p>

        <Input
          type="file"
          accept=".csv"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileSelect}
        />
      </div>

      {error && (
        <p className="text-red-500 text-xs">{error}</p>
      )}


{headers.length > 0 &&
            <p className="text-sm font-semibold">
              {csvMeta.name} ({csvMeta.records} records)
            </p>
 }
      {headers.length > 0 && (
        <Scroll height="250px" style={{border:'1px solid grey'}}>

          <div className="mt-3">

            <table className="w-full border-collapse text-xs mt-1">

              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-1">Original Header</th>
                  <th className="border p-1">Sample Data</th>
                  <th className="border p-1">Remapped Header</th>
                </tr>
              </thead>

              <tbody>
                {headers.map((h, idx) => (
                  <tr key={h}>

                    <td className="border p-1">
                      {h}
                    </td>

                    <td className="border p-1">
                      {csvData[recordIndex]?.[idx] || ''}
                    </td>

                    <td className="border p-1">
                      <select
                        value={remappedHeaders[h] || 'Select Header'}
                        onChange={(e) =>
                          handleHeaderChange(h, e.target.value)
                        }
                        className="w-full text-xs"
                      >

                        {headerOptions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}

                      </select>
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>

          </div>

        </Scroll>
      )}

      {headers.length > 0 && (

        <div className="flex justify-between items-center mt-2 text-xs">

          <div style={{ flex:'1', textAlign:'right' }}>
            {recordIndex > 1 &&
              <button
                onClick={() => handleRecordNavigation('prev')}
                className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
              >
                Prev
              </button>
            }
          </div>

          <div style={{ textAlign:'center', padding:'0px 20px' }}>
            Record {recordIndex} of {csvData.length - 1}
          </div>

          <div style={{ flex:'1', textAlign:'left' }}>
            {recordIndex < csvData.length - 1 &&
              <button
                onClick={() => handleRecordNavigation('next')}
                className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400"
              >
                Next
              </button>
            }
          </div>

        </div>
      )}

      <div className="flex justify-end mt-3 space-x-2">

        <button
          onClick={handlePrev}
          className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
        >
          Prev &lt;
        </button>

        <button
          onClick={handleNext}
          className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
        >
          Next &gt;
        </button>

      </div>

    </div>
  );
};

export default CSVRemapper;


